import React from 'react'

import {

    WideScreenContainer,
} from 'components/elements'

import PurpleAnimHeader from 'components/PurpleAnimHeader';
// import ViewAll from 'components/ViewAll';

// import {r3cPageContent} from 'constants/index'
import NewsletterSignup from 'components/NewsletterSignup';
// import {findContent, getImageDimensions, isEmptyObject} from 'generalHelpers'

import FooterAnimation from 'components/FooterAnimation'
import LearnAboutOtherNewsletters from 'components/LearnAboutOtherNewsletters';
import { NewslettersPageWrap } from '../elements';
// import useRememberScrollPosition from 'hooks/useRememberScrollPosition';
import LoadingHoc from 'hoc/LoadingHOC';

// import {Helmet} from "react-helmet";

// import useRememberScrollPosition from "../../../hooks/useRememberScrollPosition";



function WeeklyValueSignup(props) {

	const {setLoading} = props		 //receive the loading trigger change function from the HOC

	React.useEffect(() => {
			setLoading(false)
	
		// eslint-disable-next-line
	}, [])


	// useRememberScrollPosition('weekly-value-report')
	
	return (
		<NewslettersPageWrap className="pageWrapper">

			<PurpleAnimHeader
                sectionLabel={"Weekly Value"}
                sectionTitle={undefined}
				heroIntro={undefined}
				headerSplit={"3"}
                backgroundImage={"/images/weekly-value-header-dsktop.png"}
				backgroundImgMbl={"/images/weekly-value-header-mbl.png"}
				backgroundImgTitle={""}
                header={"Simplifying biopharma pricing and value, every week"}
				introCopy={"Our experts review the week in drug pricing, access and value news, delivering their high-level analysis and helping you parse the signal from the noise. "}
                titleMdPadding={"15% 0 0"}
				maxWidth={"30%"}
				marginRight={"10%"}
				maxHeight="750px"
				headerMaxWidth="63%"

            />

			<WideScreenContainer>
			<NewsletterSignup
				phoneDesktop={"/images/weekly-value-report-phone.png"}
				phoneMobile={"/images/weekly-value-report-phone.png"}
				pardotLink={"https://go.realchemistry.com/l/603341/2022-11-11/691nq"}
				/>

				<LearnAboutOtherNewsletters
				  monthly={true}
				  healthEquity={true}
				  valueReport={false}
				  displayHeader={true}
				/>

			</WideScreenContainer>

			<FooterAnimation
				svgDesktop="/images/purple-footer.svg"
				svgMobile="/images/purple-footer-mbl.svg"
				borderTop="none"
			/>
		</NewslettersPageWrap>
	)
}


export default LoadingHoc(WeeklyValueSignup);
